import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import PropTypes from 'prop-types';

Title.propTypes = {
  title: PropTypes.string
};

function Title({ title }) {
  return (
    <>
      <Box display="flex" justifyContent="center" sx={{ margin: '15px 0' }}>
        <Typography component="h2" variant="h4">
          {title}
        </Typography>
      </Box>
      <Divider />
    </>
  );
}

export default Title;
